import React, { useState } from "react";
import FoxTraderWelcome from "./FoxTraderWelcome/FoxTraderWelcome";
import KeyFeatures from "./KeyFeatures/KeyFeatures";
import Howtostart from "./howtostart/howttotradetron";
import TradeTrondownload from './TradeTronDownload/TradeTronDownload' 
import { Image } from "react-bootstrap/Image";
import CallTrackApi from "../Activity_Track/CallTrackApi";
function TradeTron() {
  window.scrollTo(0, 0)
  const [welcomeData, setWelcomeSection] = useState(
    {
      title: "TradeTron",
      content1:
        ' "Moneysukh" brought to you an ALGO trading platform in collaboration with Tradetron. Tradetron was created to empower strategy creators by allowing them to automate their quant strategies and sell them to investors and traders all over the world while not having to write a single line of code.',
      content2:
        "Tradetron is a multi-asset, multi-currency, multi-exchange Algo Strategy marketplace that allows people to create Algo strategies using their state-of-the-art, patent-pending, web-based strategy builder, which allows you to point and click to create conditions and positions that form the building blocks of an Algo strategy. Once created, it can be listed on a marketplace where people can subscribe and take the trades in their own brokerage accounts.",
    },
    []
  );
  CallTrackApi("TradeTron",window.location.href);
 
  return (
    <>
      <FoxTraderWelcome data={welcomeData} />
          <KeyFeatures />
          <Howtostart />
          <TradeTrondownload />
    </>
  );
}
export default TradeTron;

